export const celebrityStories = [
  {
    id: 'celeb-1',
    title: '顶流男星深夜密会传闻：只有代拍画面，尚无正面回应',
    summary: '连续两晚被不同网友在同一商圈提到，话题热度快速攀升。由于画面中人物遮挡较多，目前更多停留在讨论层面，建议以官方说明为准。',
    category: '明星绯闻',
    time: '今天 09:12 更新',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20an%20empty%20neon%20lit%20city%20street%20at%20night%20with%20warm%20crimson%20streetlights%20and%20blurred%20passersby%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20urban%20entertainment%20scene&width=800&height=600&seq=celebrity-night-street-01&orientation=landscape',
    tags: ['恋情传闻', '舆情升温'],
  },
  {
    id: 'celeb-2',
    title: '人气女团成员见面会临时改期，官方仅回四个字',
    summary: '原定活动在前一晚突然调整，粉丝集中询问原因。工作室统一口径为“档期调整”，并称会尽快公布新的时间安排。',
    category: '明星绯闻',
    time: '今天 08:40 更新',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20concert%20stage%20before%20the%20show%20with%20amber%20spotlights%20shining%20on%20empty%20seats%2C%20dramatic%20warm%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20music%20scene&width=800&height=600&seq=celebrity-stage-empty-02&orientation=landscape',
    tags: ['行程变动', '粉丝关注'],
  },
  {
    id: 'celeb-3',
    title: '综艺同框被反复解读，一个递水动作引发多种猜想',
    summary: '两位旧搭档被安排进同一游戏环节，现场互动自然，却被评论区放大讨论。节目组未就两人关系作出额外说明。',
    category: '吃瓜现场',
    time: '今天 10:05 更新',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20television%20studio%20set%20with%20red%20and%20gold%20lighting%20and%20blurred%20monitors%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20variety%20show%20scene&width=800&height=600&seq=celebrity-studio-set-03&orientation=landscape',
    tags: ['综艺话题', '互动解读'],
  },
  {
    id: 'celeb-4',
    title: '热播剧番位之争：片方悄悄调整物料排序',
    summary: '有观众对比新旧海报，发现演员署名顺序发生变化，随即掀起新一轮讨论。目前片方未公开回应改动原因。',
    category: '剧集动态',
    time: '今天 07:55 更新',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20dramatic%20theater%20curtains%20in%20deep%20crimson%20with%20warm%20golden%20rim%20light%2C%20soft%20film%20grain%20and%20rich%20shadow%20detail%2C%20stylized%20abstract%20performance%20scene&width=800&height=600&seq=celebrity-theater-curtain-04&orientation=landscape',
    tags: ['番位争议', '物料改动'],
  },
  {
    id: 'celeb-5',
    title: '音乐人巡演传闻发酵，票务平台预热页面流出',
    summary: '有网友晒出尚未开放的巡演页面截图，主办方暂未确认。提醒留意官方渠道，避免通过非正规途径购票造成损失。',
    category: '演出动态',
    time: '今天 11:20 更新',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20music%20festival%20crowd%20silhouette%20lit%20by%20warm%20amber%20stage%20glow%20at%20dusk%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20concert%20scene&width=800&height=600&seq=celebrity-festival-crowd-05&orientation=landscape',
    tags: ['巡演预热', '购票提醒'],
  },
  {
    id: 'celeb-6',
    title: '情侣艺人同框逛街被拍，经纪人回应“只是朋友聚会”',
    summary: '两人被拍到一前一后进入同一商场，随行还有多位工作人员。经纪人明确否认恋爱传闻，称属正常社交。',
    category: '明星绯闻',
    time: '昨天 22:18 更新',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20luxury%20shopping%20mall%20corridor%20at%20night%20with%20warm%20crimson%20highlights%20and%20blurred%20figures%2C%20dramatic%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20lifestyle%20scene&width=800&height=600&seq=celebrity-mall-corridor-06&orientation=landscape',
    tags: ['同框曝光', '官方否认'],
  },
];